<template>
  <nav style="position:static; top:0;" >

    <v-toolbar app class=" navbar elevation-0 ">
      <v-toolbar-title>
        <v-btn flat class="white--text" router to="/dashboard/usdt-cfa">
          <img src="/img/logo.png" alt="hiropay logo">
          <span class="font-weight-light">Hiro</span>
          <span>Pay</span>
        </v-btn>
      </v-toolbar-title>
      <h3 class="ml-5 orange--text font-weight-bold">{{ btcPrice }}</h3>
      <v-spacer></v-spacer>

      <div class="text-xs-center">
        <v-menu class="theme--dark" offset-y>
          <v-btn flat color="black" slot="activator" right class="hidden-md-and-up">
            <v-icon color="white" x-large>menu</v-icon>
          </v-btn>
          <v-list class="">
            <v-list-tile router :to="'/'" v-if="!auth">
              <v-icon small right>home</v-icon>
              <v-list-tile-title>Home</v-list-tile-title>
            </v-list-tile>

            <v-list-tile router :to="'/about'" v-if="!auth">
              <v-icon small right>info</v-icon>
              <v-list-tile-title>About</v-list-tile-title>
            </v-list-tile>

            <v-list-tile router :to="'/faq'" v-if="!auth">
              <v-icon small right>settings</v-icon>
              <v-list-tile-title>Faq</v-list-tile-title>
            </v-list-tile>

            <v-list-tile router :to="'/dashboard/exchange'" v-if="auth">
              <v-icon small right>dashboard</v-icon>
              <v-list-tile-title>Dashboard</v-list-tile-title>
            </v-list-tile>

            <v-list-tile router  :to="'/dashboard/exchange'" v-if="auth">
              <v-icon small right>autorenew</v-icon>
              <v-list-tile-title>SWAP Echange</v-list-tile-title>
            </v-list-tile>

            <v-list-tile router href="/dashboard/funds" v-if="auth">
              <v-icon small right>money</v-icon>
              <v-list-tile-title>Funds</v-list-tile-title>
            </v-list-tile>

            <v-list-tile router :to="'/dashboard/account'" v-if="auth">
              <v-icon small right>account_circle</v-icon>
              <v-list-tile-title>Account</v-list-tile-title>
            </v-list-tile>
            <v-btn color="primary" router :to="'/register'" v-if="!auth">
              <span class="btn white--text">S'inscrire</span>
            </v-btn>

            <div v-if="!auth">
              <v-btn color="success" router :to="'/login'" v-if="!auth">
              <span class="btn white--text">connexion</span>
            </v-btn>
            </div>

            <!-- <div v-if="!auth">
              <SignIn/>
            </div> -->
            <v-btn color="secondary" @click="logout()" v-if="auth">
              <span class="white--text text-capitalize">Logout</span>
            </v-btn>
          </v-list>
        </v-menu>
      </div>

      <v-toolbar-items class="hidden-sm-and-down navbar">
        <v-btn flat class="mx-4" color="#b388ff deep-purple accent-1" router :to="'/'" v-if="!auth">
          <v-icon small right color="white">home</v-icon>
          <span class="white--text text-capitalize">accueil</span>
        </v-btn>

        <v-btn flat class="mx-4" color="#b388ff deep-purple accent-1" router :to="'/about'" v-if="!auth">
          <v-icon small right color="white">info</v-icon>
          <span class="white--text text-capitalize">apropos</span>

        </v-btn>

        <v-btn flat class="mx-4" color="#b388ff deep-purple accent-1" router :to="'/faq'" v-if="!auth">
          <v-icon small right color="white">settings</v-icon>
          <span class="white--text text-capitalize">Faq</span>
        </v-btn>


        <!-- <v-btn flat color="#b388ff deep-purple accent-1" router :to="'/dashboard/exchange'" v-if="auth">
          <v-icon small right color="white">dashboard</v-icon>
          <span class="white--text text-capitalize">Dashboard</span>

        </v-btn> -->

        <v-btn flat color="#b388ff deep-purple accent-1" router :to="'/dashboard/exchange'" v-if="auth">
          <v-icon small right color="white">autorenew</v-icon>
          <span class="white--text text-capitalize">SWAP ECHANGE</span>

        </v-btn>

        <v-btn flat color="#b388ff deep-purple accent-1" router href="/dashboard/funds" v-if="auth">
          <v-icon small rightcolor="white">money</v-icon>
          <span class="white--text text-capitalize">solde</span>
        </v-btn>

        <v-btn flat color="#b388ff deep-purple accent-1" router :to="'/dashboard/account'" v-if="auth">
          <v-icon small rightcolor="white">account_circle</v-icon>
          <span class="white--text text-capitalize">compte</span>
        </v-btn>

        <v-btn flat color="#b388ff deep-purple accent-1" @click="logout()" v-if="auth">
          <span class="white--text text-capitalize">Logout</span>
        </v-btn>

      </v-toolbar-items>
      <div class="hidden-sm-and-down mx-4">
        <v-btn color="primary" router :to="'/register'" v-if="!auth && user === null">
          <span class="btn white--text">S'inscrire</span>
        </v-btn>
      </div>

      <div v-if="!auth" class="hidden-sm-and-down">
        <v-btn color="success" router :to="'/login'" v-if="!auth && user === null">
        <span class="btn white--text">connexion</span>
      </v-btn> 
              
            </div>


    </v-toolbar>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
export default {
  data() {
    return {
      pwa: false,
      menu: [
        { title: "accueil", icon: "home", link: "/" },
        { title: "a propos", icon: "info", link: "/about" },
        { title: "faq", icon: "settings", link: "/faq" },
        { title: "Dashboard", icon: "dashboard", link: "/dashboard/usdt-cfa" },
        { title: "solde", icon: "", link: "/dashboard/funds" }
      ],
      btcPrice: ""
    };
  },
  computed: {
    ...mapGetters("authfb", ["user", "auth"])
  },

  mounted() {
    console.log('mobile', this.$device.mobile);
    const standalone = () => (window.matchMedia('(display-mode: standalone)').matches);
    this.pwa = standalone()

    axios({
      method: "GET",
      url: "https://blockchain.info/ticker",
      json: true
    }).then(
      result => {

        var btcPrice = result.data.USD.last;
        this.btcPrice = btcPrice

      },
      error => {
        console.log(error);
      }
    );

    this.$store.dispatch("authfb/checkUserStatus");
  },
  methods: {
    ...mapActions("authfb", ["logout"])
  }
};
</script>

<style scoped>
a.v-btn {
  text-decoration: none !important;
}

a.v-list__tile {
  text-decoration: none !important;
}

.text-capitalize {
  font-family: 'Titillium Web' !important;
  font-weight: 600;
  text-transform: uppercase !important;
  letter-spacing: 1px;
  font-size: 15px;

}

.theme--light.v-toolbar {
  background-color: #003449 !important;
}
</style>
